import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import BuscarViagens from "@/pages/BuscarViagens";
import Conheca from "@/pages/Conheca";
import TrabalheConosco from "@/pages/TrabalheConosco";
import Contato from "@/pages/Contato";
import PerguntasFrequentes from "@/pages/PerguntasFrequentes";
import Documentos from "@/pages/Documentos";
import SeguroViagem from "@/pages/SeguroViagem";
import AvalieSuaViagem from "@/pages/AvalieSuaViagem";
import Seguranca from "@/pages/Seguranca";
import TermosDeUso from "@/pages/TermosDeUso";
import PoliticaDePrivacidade from "@/pages/PoliticaDePrivacidade";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/buscar-viagens" element={<BuscarViagens />} />
          <Route path="/conheca" element={<Conheca />} />
          <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/perguntas-frequentes" element={<PerguntasFrequentes />} />
          <Route path="/documentos" element={<Documentos />} />
          <Route path="/seguro-viagem" element={<SeguroViagem />} />
          <Route path="/avalie-sua-viagem" element={<AvalieSuaViagem />} />
          <Route path="/seguranca" element={<Seguranca />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
